"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedPropertyCompactsToSavedResultItems = void 0;
var effects_1 = require("redux-saga/effects");
var savedPropertyResultToSavedProperties_1 = require("@/transformers/savedPropertyResultToSavedProperties");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SavePropertiesApiSaga_1 = require("@/pages/saveproperties/sagas/api/SavePropertiesApiSaga");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var getResultPageTranslation = function (state) { return state.resultT; };
exports.savedPropertyCompactsToSavedResultItems = function (savedPropertyCompacts) {
    var languageId, t, imgDomain, savedProperties, properties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 1:
                languageId = _a.sent();
                return [4 /*yield*/, effects_1.select(getResultPageTranslation)];
            case 2:
                t = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getImageDomain)];
            case 3:
                imgDomain = _a.sent();
                savedProperties = savedPropertyCompacts.map(function (it) { return savedPropertyResultToSavedProperties_1.transformSaveProperty(it, imgDomain); });
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getPropertiesDetailByIdsApi, savedProperties.map(function (it) { return Number(it.referenceId); }))];
            case 4:
                properties = (_a.sent()).data.properties;
                return [2 /*return*/, savedProperties
                        .map(function (it) {
                        var detail = properties.find(function (it2) { return Number(it2.id) === Number(it.referenceId); });
                        if (!detail)
                            return;
                        var amenities = [];
                        if (detail.bedrooms) {
                            amenities.push({
                                key: 'bed',
                                value: detail.bedrooms,
                                displayKey: t['bedrooms'],
                                displayValue: detail.bedrooms + " " + t['bd'],
                            });
                        }
                        if (detail.bathrooms) {
                            amenities.push({
                                key: 'bed',
                                value: detail.bathrooms,
                                displayKey: t['bathrooms'],
                                displayValue: detail.bathrooms + " " + t['ba'],
                            });
                        }
                        return __assign(__assign({}, it), { amenities: amenities, address: searchResponseToResultPage_1.getAddress(detail.streetNo, detail.streetName, t, languageId), banners: detail.banners });
                    })
                        .filter(function (it) { return it; })];
        }
    });
};
